import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { I18nService } from './app/core/i18n/i18n.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    appRef.injector.get(I18nService).init();
  })
  .catch((error) => {
    console.error(error);
  });
